// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3S9VO","addWidgetButton":"Header_addWidgetButton__28Zez","dashboardTabs":"Header_dashboardTabs__1RFES","active":"Header_active__1ve07"};